import { Component } from '@angular/core';

@Component({
  selector: 'itl-desktop-header',
  templateUrl: './desktop-header.component.html',
  styleUrls: ['./desktop-header.component.scss'],
  standalone: false,
})
export class DesktopHeaderComponent {}
